import React from 'react';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import ScanSoundFileTable from './components/ScanSoundFileTable';
import WarehouseAccountConfigTab from './components/WarehouseAccountConfigTab';

const PdaScanConfigPage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div style={{ padding: 16 }}>
            <Tabs
                items={[
                    {
                        key: 'account',
                        label: t('pdaScanConfig.tab.account'),
                        children: <WarehouseAccountConfigTab />,
                    },
                    {
                        key: 'soundFile',
                        label: t('pdaScanConfig.tab.soundFile'),
                        children: <ScanSoundFileTable />,
                    },
                ]}
            />
        </div>
    );
};

export default PdaScanConfigPage;
